import axios from 'axios'
import _ from 'lodash'
import EventBus from '@/controllers/EventBus'

export default {
  // callback format: (result, data, error)
  post (path, data, headers = {}) {
    // context.$http.interceptors.push(function (request, next) {
    //   request.headers.set('Access-Control-Allow-Origin', '*')
    //   next()
    // })

    _.merge(data, {
      client_id: 1,
      client_secret: 'n4FdG7FaF14ka2id8WySAwHTtgdAGwBQTqovmeW0'
    })

    return new Promise((resolve, reject) => {
      axios.post(path, data, { headers }
      ).then(response => {
        // console.log('response')
        // console.log(response)
        if (!response.data) {
          // EventBus.$emit('unauthenticated')
          // callback(false, { error: 'Invalid response', code: 400 })
          reject(new Error('Invalid response'))
          // reject({ error: 'Invalid response', code: 400 })
          return
        }

        // validate if proper JSON
        if (typeof response.data !== 'object') {
          reject(new Error('Invalid JSON data'))
          // console.log(response)
          // reject({ error: 'Invalid JSON data', code: 400 })
          return
        }

        if (response.data.error) {
          let error = new Error(response.data.error && response.data.error.msg)
          error.code = response.data.error && response.data.error.code
          return
        }

        // EventBus.$emit('authenticated', response.data)
        // callback(true)
        resolve(response.data)
      }).catch(error => {
        console.error('post error', error)
        if (!error) {
          reject(new Error('Blank error response'))
          // reject({ error: 'Blank error response', code: 400 })
          return
        }

        // console.log(error)
        if (!error.response ||
          !error.response.data) {
          // EventBus.$emit('unauthenticated')
          // callback(context, false, { error: 'Invalid error response', code: 400 })
          reject(new Error('Invalid error response'))
          // reject({ error: 'Invalid error response', code: 400 })
          return
        }

        // validate if proper JSON
        if (typeof error.response.data !== 'object') {
          reject(new Error('Invalid JSON error'))
          // console.error(error.response)
          // reject({ error: 'Invalid JSON error', code: 400 })
          return
        }

        if (error.response.data.code === 401) {
          EventBus.$emit('unauthenticated')
        }

        // mitigate error into message
        if (error.response.data &&
          error.response.data.error) {
          const err = error.response.data.error
          if (typeof err === 'string') {
            error.response.data.message = err
          } else if (typeof err === 'object') {
            // consolidate error object/array
            const all = _.flatMap(err, (item, key) => {
              return _.map(item, (subitem, subkey) => {
                return `${key}: ${typeof subitem === 'object' ? `${subkey}: ${JSON.stringify(subitem)}` : subitem}`
              })
            })
            error.response.data.message = all.join('; ')
          }
        }

        // EventBus.$emit('unauthenticated')
        // callback(context, false, error.response.data)
        reject(error.response.data)
      })
    })

    // context.$http.post(LOGIN_URL, creds, {
    //   headers: {
    //     // 'Access-Control-Allow-Methods': '*'
    //   }
    // }).then(data => {
    //   console.log(data)
    //   localStorage.setItem('id_token', data.id_token)
    //   localStorage.setItem('access_token', data.access_token)
    //
    //   this.user.authenticated = true
    //
    //   // Redirect to a specified route
    //   if (redirect) {
    //     console.log('redirected')
    //     // router.go(redirect)
    //   }
    // }, err => {
    //   console.log('error login')
    //   console.log(err)
    //   context.error = err
    // })
  },
  get (path, params, headers = {}) {
    return new Promise((resolve, reject) => {
      axios.get(path,
        {
          params: params,
          headers: {
            // 'HTTP_ORIGIN': 'http://localhost:8080',
            ...headers,
          },
        }
      ).then(response => {
        // console.log('response')
        // console.log(response)
        if (!response.data) {
          // EventBus.$emit('unauthenticated')
          // callback(false, { error: 'Invalid response', code: 400 })
          reject(new Error('Invalid response'))
          // reject({ error: 'Invalid response', code: 400 })
          return
        }

        // validate if proper JSON
        if (typeof response.data !== 'object') {
          reject(new Error('Invalid JSON data'))
          // reject({ error: 'Invalid JSON data', code: 400 })
          return
        }

        if (response.data.error) {
          let error = new Error(response.data.error && response.data.error.msg)
          error.code = response.data.error && response.data.error.code
          reject(error)
          // reject({ error: response.data.error.msg, code: response.data.error.code })
          return
        }

        // EventBus.$emit('authenticated', response.data)
        // callback(true)
        resolve(response.data)
      }).catch(error => {
        console.error('get error', error)
        if (!error) {
          reject(new Error('Blank error response'))
          // reject({ error: 'Blank error response', code: 400 })
          return
        }

        // console.log(error)
        if (!error.response ||
          !error.response.data) {
          // EventBus.$emit('unauthenticated')
          // callback(context, false, { error: 'Invalid error response', code: 400 })
          reject(new Error('Invalid error response'))
          // reject({ error: 'Invalid error response', code: 400 })
          return
        }

        // validate if proper JSON
        if (typeof error.response.data !== 'object') {
          reject(new Error('Invalid JSON error'))
          // reject({ error: 'Invalid JSON error', code: 400 })
          return
        }

        if (error.response.data.code === 401) {
          EventBus.$emit('unauthenticated')
        }

        // EventBus.$emit('unauthenticated')
        // callback(context, false, error.response.data)
        reject(error.response.data)
      })
    })
  }
}
